import React from 'react';
import { useReveal } from '../lib/useReveal';
export function FinalCTASection() {
  const [ref, vis] = useReveal();
  return <section id="cta" className="bg-[#E8E0D3] py-6 md:py-12 px-4 sm:px-6 border-t border-[#2E4F48]/15" data-id="element-75">
      <div className="container mx-auto max-w-3xl" data-id="element-76">
        <div ref={ref} className={`reveal text-center ${vis ? 'is-visible' : ''}`} data-id="element-77">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#1C3B36] mb-5" data-id="element-78">
            Empezá hoy tu formación en{' '}
            <span className="text-[#C2683D] italic" data-id="element-79">Biodescodificación</span>
          </h2>

          <p className="text-[#44574F] text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-10" data-id="element-80">
            Accedé inmediatamente a todos los tomos, recursos y herramientas
            profesionales.
          </p>

          <a href="#pricing" className="inline-block w-full sm:w-auto px-10 py-5 rounded-xl text-white font-bold text-base md:text-lg tracking-widest uppercase transition-all shadow-[0_10px_25px_rgba(28,59,54,0.25)] hover:shadow-[0_14px_32px_rgba(28,59,54,0.35)] hover:-translate-y-1 bg-[#2E4F48] hover:bg-[#1C3B36]" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-81">
            Quiero acceder ahora →
          </a>

          <p className="text-[#44574F] text-xs sm:text-sm mt-6 font-bold" data-id="element-82">
            🛡️ Garantía de satisfacción 7 días · 🔒 Pago seguro · ⚡ Acceso
            inmediato
          </p>

          <div className="mt-12 pt-8 border-t border-[#2E4F48]/20" data-id="element-83">
            <p className="text-[#44574F] text-xs md:text-sm font-bold tracking-[0.3em] uppercase" data-id="element-84">
              Academia Holística Argentina
            </p>
          </div>
        </div>
      </div>
    </section>;
}